import { useEffect, useRef, useState } from 'react';

// Small helpers shared by the prize wheel page and its dialogs.

export const locale = (lang) => (lang === 'hu' ? 'hu-HU' : 'en-GB');

export function fmtDateTime(ms, lang, { weekday = false } = {}) {
  if (ms === null || ms === undefined) return '—';
  return new Intl.DateTimeFormat(locale(lang), {
    ...(weekday ? { weekday: 'short' } : {}),
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(ms));
}

export const fmtNum = (n, lang) => new Intl.NumberFormat(locale(lang)).format(n ?? 0);

export function useNow(intervalMs) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!intervalMs) return undefined;
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}

// Escape closes, unless something is in flight.
export function useEscape(onClose, busy) {
  const ref = useRef(onClose);
  ref.current = onClose;
  useEffect(() => {
    function onKey(e) {
      if (e.key === 'Escape' && !busy) ref.current();
    }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [busy]);
}

